import { type ArticleCardProps } from '3-components/ArticleCard/ArticleCard';
import { type AssetsListingQuery, type ArticleListingQuery } from 'cms/cms';
import HTMLReactParser from 'html-react-parser';
import { resolveCategoriesToBadges } from './badgeResolver';
import { resolveImageReferenceToImage } from './imageResolver';
import type { ContentAreaItemModelSearch, ContentModelReference } from 'cms/cms-types';
import { resolveDate } from './dateResolver';
import { resolveMinRead } from './minReadResolver';
import { resolveAuthorsToCardAuthors } from './authorResolver';

export type ArticlePage = NonNullable<ArticleListingQuery['ArticlePage']>;
export type ArticlePageItems = NonNullable<ArticlePage['items']>;
export interface ArticleCardResolverSettings {
    minReadSuffix: string;
    minWatchSuffix: string;
}

export const resolveArticlePagesToArticleCards = (items: ArticlePageItems, settings: ArticleCardResolverSettings): ArticleCardProps[] => {
    return items.map(item => {
        // the autogenerated produce | null for each item, need to remove the | null type
        const { Title, PreviewTitle, PreviewDescription, MediaTypeCategories, PreviewImage, ArticlePublishDate, ReadTimeInMins, WatchTimeInMins, VideoUrl, Authors, ContentLink } = item as NonNullable<typeof item>;
        const tags = resolveCategoriesToBadges(MediaTypeCategories, !!VideoUrl);
        const imgSrcSets = [480, 767];
        const img = resolveImageReferenceToImage(PreviewImage as ContentModelReference, '?width=460', imgSrcSets);
        const date = resolveDate(ArticlePublishDate);
        const minRead = resolveMinRead(VideoUrl ? WatchTimeInMins : ReadTimeInMins, VideoUrl ? settings?.minWatchSuffix : settings?.minReadSuffix);
        const authors = resolveAuthorsToCardAuthors(Authors as ContentAreaItemModelSearch[]);

        return {
            ...(ContentLink?.Url && { link: { href: ContentLink.Url } }),
            title: PreviewTitle || Title as string,
            ...(PreviewDescription && { children: HTMLReactParser(PreviewDescription as string) }),
            tags,
            ...(img && { img }),
            date,
            minRead,
            authors,
        };
    });
};

export type AssetPage = NonNullable<AssetsListingQuery['AssetPage']>;
export type AssetPageItems = NonNullable<AssetPage['items']>;

export const resolveAssetPagesToArticleCards = (items: AssetPageItems): ArticleCardProps[] => {
    return items.map(item => {
        // the autogenerated produce | null for each item, need to remove the | null type
        const { Title, PreviewTitle, PreviewDescription, PreviewImage, AssetTypeCategories, ContentLink } = item as NonNullable<typeof item>;
        const tags = resolveCategoriesToBadges(AssetTypeCategories);
        const imgSrcSets = [480, 767];
        const img = resolveImageReferenceToImage(PreviewImage as ContentModelReference, '?width=768', imgSrcSets);

        return {
            ...(ContentLink?.Url && { link: { href: ContentLink.Url } }),
            title: PreviewTitle || Title as string,
            ...(PreviewDescription && { children: HTMLReactParser(PreviewDescription as string) }),
            tags,
            ...(img && { img }),
        };
    });
};
